module.exports = __webpack_public_path__ + "img/logo_en.2b98da6d.png";